export enum TableViewTogglesValues {
    VIEW_TYPE_SINGLE_CARD = 'SINGLE_CARD',
    VIEW_TYPE_MULTI_CARDS = 'MULTI_CARDS',
    VIEW_TYPE_TABLE = 'TABLE',
}
